var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"SectionPlantTypes"}},[_c('Wrap',{staticClass:"lg"},[_c('h2',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.$t('title'))+" ")]),_vm._l((_vm.plants),function(plant){return _c('CardPlant',{key:plant.label,attrs:{"plant":plant}})})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }